// extracted by mini-css-extract-plugin
export var collapsable = "index-module--collapsable--QVieN";
export var button = "index-module--button--KHmyP";
export var labelContainer = "index-module--labelContainer--3RGyT";
export var arrowDown = "index-module--arrowDown--bgVQg";
export var arrowUp = "index-module--arrowUp--1sl45";
export var container = "index-module--container--FFhkN";
export var content = "index-module--content--1tW4Z";